export default __webpack_public_path__ + "static/media/portugal.0ba4bbf3.webp";